import { useDroppable } from "@dnd-kit/core";

const Droppable = ({ children }) => {
  const { setNodeRef, isOver } = useDroppable({ id: "canvas" });

  return (
    <div
      ref={setNodeRef}
      style={{
        minHeight: "80vh",
        padding: "16px",
        border: "2px dashed #cbd5e1",
        background: isOver ? "#eef6ff" : "#f8fafc",
        borderRadius: "5px",
      }}
    >
      {children}
    </div>
  );
};

export default Droppable;
